import React, { useContext } from 'react';
import { Auth } from 'aws-amplify';

import { AuthenticatorContext } from './AuthenticatorContext';
import {
   AuthenticatorButton,
   AuthenticatorForm,
   AuthenticatorInput,
   AuthenticatorSubmitButton,
} from './AuthenticatorForm';

const SignUp = () => {
   const { dispatch } = useContext(AuthenticatorContext);
   return (
      <AuthenticatorForm
         heading="Sign Up"
         onSubmit={(formData) =>
            Auth.signUp({
               username: formData.get('email'),
               password: formData.get('password'),
               attributes: {
                  name: formData.get('name'),
               },
            }).then(({ user }) => {
               dispatch({
                  type: 'changeView',
                  view: 'confirmSignUp',
                  userData: {
                     email: user.username,
                     password: formData.get('password'),
                  },
               });
            })
         }
      >
         <AuthenticatorInput
            name="name"
            autoComplete="given-name"
            placeholder="First Name"
            required
            autoFocus
         />
         <AuthenticatorInput
            name="email"
            type="email"
            autoComplete="email"
            placeholder="Email"
            required
         />
         <AuthenticatorInput
            name="password"
            type="password"
            autoComplete="new-password"
            placeholder="Password"
            required
            minLength="8"
         />
         <AuthenticatorSubmitButton>Sign Up</AuthenticatorSubmitButton>
         <p>
            Already have an account?{' '}
            <AuthenticatorButton
               className="button-link"
               onClick={() => dispatch({ type: 'changeView', view: 'logIn' })}
            >
               Log In
            </AuthenticatorButton>
         </p>
      </AuthenticatorForm>
   );
};

export { SignUp };
